import React from 'react';
import { string, shape } from 'prop-types';

export default function BgTile({ item }) {
    return (
        <a href={item.url} className="c-bg-tile" style={{ backgroundImage: item.thumbnail }}>
            <div className="tile-content">
                <h4>{item.title}</h4>
                {item.excerpt && <p className="subtext">{item.subtext}</p>}
            </div>
        </a>
    );
}

BgTile.propTypes = {
    item: shape({
        url: string.isRequired,
        thumbnail: string.isRequired,
        title: string.isRequired,
        subtext: string
    }).isRequired
};
